import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../redux/actions/authActions";
import "./logout.css";
import { logoutUser } from "../../../services/authAPI.js";

const LogoutButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);

  if (!isAuthenticated) return null; // ── hidden when not logged in ──

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem("refreshToken");

    try {
      if (refreshToken) await logoutUser(refreshToken);
    } catch (error) {
      console.error("Logout request failed", error);
    }

    dispatch(logout());
    navigate("/");
  };

  return (
    <button className='logout-btn' onClick={handleLogout}>
      Log Out
    </button>
  );
};

export default LogoutButton;
